/* Goggles: one flat price everywhere. Kept as a file only so the head snippet
   does not reference a missing asset; it now just pins the label. */
(function(){
var P=window.IF_GOGGLE_PRICES||{standard:22.95,was:'39.95'};
function paint(){
var w=document.getElementById('if-addons');
if(!w)return;
var spans=w.querySelectorAll('span');
for(var i=0;i<spans.length;i++){
var s=spans[i];
if(s.textContent.indexOf('BUNDLE PRICE')>-1){s.textContent='';}
}
var head=w.querySelector(':scope > div');
if(head){var tag=head.querySelectorAll('span')[1];if(tag&&tag.textContent!=='43% OFF')tag.textContent='43% OFF';}
}
setInterval(paint,900);
if(document.readyState!=='loading')paint();else document.addEventListener('DOMContentLoaded',paint);
})();
